import * as authApi from "../api/auth";
import { baseUrl } from "../config/api-config.js";

import {
  auth as actionType,
  handleAxiosError,
} from "../config/action-config.js";
import axios from "axios";
import { errorAlert } from "./alert";

export const getUser = (token) => async (dispatch) => {
  try {
    dispatch({ type: actionType.SUSPENSE });
    const { data } = await authApi.fetchTokenUser(token);
    dispatch({
      type: actionType.FETCH_SUCCESS,
      payload: { ...data, token },
    });
  } catch (error) {
    localStorage.clear();
    sessionStorage.clear();
    dispatch({ type: actionType.LOGOUT, payload: null });
    window.location.reload();
    //   handleAxiosError(error);
    //   dispatch({
    //     type: actionType.FETCH_FAILURE,
    //     payload: { message: "Please Try Login Again" },
    //   });
  }
};

export const loginWithEmail =
  ({ email, password }, setErrorMessage) =>
  async (dispatch) => {
    try {
      dispatch({ type: actionType.SUSPENSE });
      const { data } = await authApi.emailLogin(email, password);
      if (!data.mfa) {
        localStorage.setItem("token", data.token);
        dispatch({ type: actionType.LOGIN_SUCCESS, payload: data });
      } else {
        sessionStorage.setItem("email", data.email);
        window.location.replace(window.location.origin + "/verify-mfa");
      }
    } catch (error) {
      const res = error.response?.data;
      dispatch({
        type: actionType.LOGIN_FAILURE,
        payload: "",
        // payload: res?.error || error.message,
      });
      return res;
    }
  };

export const logout = () => async (dispatch) => {
  localStorage.removeItem("token");
  dispatch({ type: actionType.LOGOUT });
};

export const microsoftLogin = () => (dispatch) => {
  dispatch({ type: actionType.SUSPENSE });
  window.location.replace(`${baseUrl}/auth/outlook`);
};

export const microsoftCallback = (query) => async (dispatch) => {
  try {
    const { data } = await authApi.microsoftCallback(query);
    dispatch({ type: actionType.LOGIN_SUCCESS, payload: data });
  } catch (error) {
    const res = error.response?.data;
    dispatch({
      type: actionType.LOGIN_FAILURE,
      payload: res?.error || error.message,
    });
  }
};

export const teamsCallback = (query) => async (dispatch) => {
  try {
    const { data } = await authApi.teamsCallback(query);
    console.log(data);
    dispatch({
      type: actionType.UPDATE_SUCCESS,
      payload: { msTeamsAuth: data.token },
    });
    window.location.replace(window.location.origin + "/meetings/new");
  } catch (error) {
    dispatch(errorAlert("Some Error Occured. Please Try again later."));
  }
};
